/* PoscART — /pages/usage helpers                         (2026-09-13)
 * ---------------------------------------------------------------------------
 * Two things the two-column step layout needs:
 *   1. the infographics now render at 400px, so clicking one opens it full size
 *   2. the step nav is sticky, so the current step is marked as you scroll
 * No-ops on every page that has no .pa-use block.
 */
(function () {
  'use strict';

  function lightbox(src, alt) {
    var box = document.createElement('div');
    box.className = 'pa-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', alt || 'Enlarged diagram');

    var img = document.createElement('img');
    img.src = src;
    img.alt = alt || '';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pa-lightbox__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

    box.appendChild(img);
    box.appendChild(close);
    document.body.appendChild(box);
    close.focus();

    function dismiss() {
      box.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(event) {
      if (event.key === 'Escape') dismiss();
    }

    box.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey);
  }

  function init() {
    var root = document.querySelector('.pa-use');
    if (!root || root.dataset.paUse === '1') return;
    root.dataset.paUse = '1';

    // 0. floats only affect what follows them, and each figure sits AFTER its
    //    step's intro copy, so move it to the front of the step at desktop
    //    widths and the text wraps beside it instead of under it.
    var steps0 = Array.prototype.slice.call(root.querySelectorAll('.pa-use__step'));
    var moved = steps0.map(function (step) {
      var fig = step.querySelector(':scope > .pa-use__fig');
      var cap = step.querySelector(':scope > .pa-use__cap');
      return fig ? { step: step, fig: fig, cap: cap, after: fig.nextElementSibling } : null;
    }).filter(Boolean);

    var isWide = null;
    function layout() {
      var wide = window.innerWidth >= 1000;
      if (wide === isWide) return;
      isWide = wide;
      moved.forEach(function (m) {
        if (wide) {
          m.step.insertBefore(m.fig, m.step.firstChild);
          if (m.cap) m.step.insertBefore(m.cap, m.fig.nextSibling);
        } else {
          if (m.after && m.after.parentNode === m.step) {
            m.step.insertBefore(m.fig, m.after);
          } else {
            m.step.appendChild(m.fig);
          }
          if (m.cap) m.step.insertBefore(m.cap, m.fig.nextSibling);
        }
      });
    }
    layout();
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(layout, 150);
    });

    // 1. click a figure to see it full size
    root.addEventListener('click', function (event) {
      var fig = event.target.closest ? event.target.closest('.pa-use__fig') : null;
      if (!fig || !root.contains(fig)) return;
      if (window.innerWidth < 1000) return; // already full width on small screens
      var img = fig.querySelector('img');
      if (img) lightbox(img.currentSrc || img.src, img.alt);
    });

    // 2. mark the step you are looking at in the sticky nav
    var links = {};
    Array.prototype.slice.call(root.querySelectorAll('.pa-use__nav a')).forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') links[href.slice(1)] = a;
    });

    var steps = Array.prototype.slice.call(root.querySelectorAll('.pa-use__step[id]'));
    if (!steps.length || !Object.keys(links).length) return;
    if (!('IntersectionObserver' in window)) return;

    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { seen[entry.target.id] = entry.isIntersecting; });

      var current = null;
      for (var i = 0; i < steps.length; i++) {
        if (seen[steps[i].id]) { current = steps[i].id; break; }
      }

      Object.keys(links).forEach(function (id) {
        links[id].classList.toggle('is-current', id === current);
      });
    }, { rootMargin: '-120px 0px -55% 0px', threshold: 0 });

    steps.forEach(function (step) { observer.observe(step); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
